import { useState, useEffect } from 'react'
import MediaCard from '../../../components/MediaCard/MediaCard'
import { fetchGalleryImages } from '../../../services/api'
import style from './imagegallerygrid.module.scss'
import PaginationControl from '../../../components/PaginationControl/PaginationControl'

const ImageGalleryGrid = () => {
    const [images, setImages] = useState([])
    const [loading, setLoading] = useState(true)
    const [pagination, setPagination] = useState({})
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        const loadImages = async () => {
            setLoading(true)
            try {
                const { data, pagination } = await fetchGalleryImages({
                    page: currentPage,
                    pageSize: 3
                })
                // Format the data to handle Strapi's nested structure
                const formattedImages = data.map(item => ({
                    id: item.id,
                    title: item.attributes.Title || 'Image', // Default title if none exists
                    imageUrl: item.attributes.Image?.data?.attributes?.url
                        ? `${item.attributes.Image.data.attributes.url}`
                        : null,
                    // Optionally include different image formats if needed
                    formats: item.attributes.Image?.data?.attributes?.formats || null
                }))
                
                setImages(formattedImages)
                setPagination(pagination)
            } catch (error) {
                console.error('Failed to load images:', error)
            } finally {
                setLoading(false)
            }
        }

        loadImages()
    }, [currentPage])

    return (
        <div className={style.imagegallerygrid}>
            <div className={style.wrapperImages}>
                {loading ? (
                    <div>Loading images...</div>
                ) : (
                    images.map(item => (
                        <MediaCard
                            key={item.id}
                            title={item.title}
                            media={item.imageUrl}
                            width='90%'
                            isVideo={false}
                        />
                    ))
                )}
            </div>
            {pagination.pageCount > 1 && (
                <div className={style.wrapperBtn}>
                    <PaginationControl
                        page={currentPage}
                        setPage={setCurrentPage}
                        pageCount={pagination.pageCount}
                    />
                </div>
            )}
        </div>
    )
}

export default ImageGalleryGrid